// indonesiaV2Language.ts
// ─── Astria Indonesia v2 — EN/ID language ──────────────────────────────────
// Follows the user's preferred language (utils/appLanguage.ts): ID when
// that is the preference, English otherwise. No per-screen toggle.
import { getAppLanguage, pickLanguage, useAppLanguage } from "../../../utils/appLanguage";

export type IndonesiaV2Lang = "en" | "id";

const SUPPORTED: readonly IndonesiaV2Lang[] = ["en", "id"];
const ALIASES: Partial<Record<string, IndonesiaV2Lang>> = {};

const resolve = (appLanguage: string): IndonesiaV2Lang =>
  pickLanguage(appLanguage, SUPPORTED, ALIASES);

export const getIndonesiaV2Lang = (): IndonesiaV2Lang => resolve(getAppLanguage());

export function useIndonesiaV2Language(): IndonesiaV2Lang {
  return resolve(useAppLanguage());
}
